export default function TechnicalSection() {
  const technicalFeatures = [
    {
      icon: "ri-dashboard-line",
      title: "Contrôle Intelligent",
      description: "Systèmes de régulation automatique avec capteurs d'hygrométrie et de température pour un pilotage précis et autonome."
    },
    {
      icon: "ri-flashlight-line",
      title: "Haute Performance",
      description: "Capacités de déshumidification de 50 à 500 litres par jour selon les modèles, adaptées à toutes les surfaces de serres."
    },
    {
      icon: "ri-leaf-line",
      title: "Efficacité Énergétique",
      description: "Technologies à récupération de chaleur permettant de réduire simultanément l'humidité et les coûts de chauffage."
    },
    {
      icon: "ri-shield-check-line",
      title: "Robustesse Professionnelle",
      description: "Équipements conçus pour fonctionner en continu dans des environnements agricoles exigeants avec une durée de vie prolongée."
    },
    {
      icon: "ri-smartphone-line",
      title: "Pilotage à Distance",
      description: "Supervision et contrôle via application mobile pour surveiller et ajuster les paramètres depuis n'importe où."
    },
    {
      icon: "ri-alarm-warning-line",
      title: "Alertes Intelligentes",
      description: "Notifications en temps réel en cas d'anomalie ou de dépassement des seuils d'hygrométrie programmés."
    }
  ];

  return (
    <section className="py-20 bg-slate-800">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-white mb-4">Caractéristiques Techniques</h2>
          <p className="text-xl text-slate-300 max-w-3xl mx-auto">
            Des équipements de pointe pour un contrôle optimal de l'hygrométrie
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {technicalFeatures.map((feature, index) => (
            <div 
              key={index} 
              className="bg-slate-900 p-6 rounded-xl hover:bg-slate-700 transition-all duration-300"
            >
              <div className="w-14 h-14 bg-[#4F8B3A] rounded-lg flex items-center justify-center mb-4">
                <i className={`${feature.icon} text-2xl text-white`}></i>
              </div>
              <h3 className="text-xl font-bold text-white mb-3">{feature.title}</h3>
              <p className="text-slate-300 leading-relaxed">{feature.description}</p>
            </div>
          ))}
        </div>

        {/* Technical Specifications */}
        <div className="mt-16 bg-slate-900 rounded-2xl p-8">
          <h3 className="text-2xl font-bold text-white mb-8 text-center">Spécifications Techniques</h3>
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
            <div className="text-center">
              <div className="text-4xl font-bold text-[#4F8B3A] mb-2">50-500L</div>
              <div className="text-slate-300">Capacité par jour</div>
            </div>
            <div className="text-center">
              <div className="text-4xl font-bold text-[#4F8B3A] mb-2">±2%</div>
              <div className="text-slate-300">Précision hygrométrie</div>
            </div>
            <div className="text-center">
              <div className="text-4xl font-bold text-[#4F8B3A] mb-2">24/7</div>
              <div className="text-slate-300">Fonctionnement continu</div>
            </div>
            <div className="text-center">
              <div className="text-4xl font-bold text-[#4F8B3A] mb-2">10 ans</div>
              <div className="text-slate-300">Durée de vie moyenne</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
